import { formatDateForInput, getMondayOfWeekLocal } from "./dateUtils";

/**
 * @param {number} totalMinutes
 * @returns {string} e.g. "0m", "40m", "3h 20m"
 */
export function formatCompactLoggedDuration(totalMinutes) {
  const t = Math.max(0, Math.round(Number(totalMinutes) || 0));
  if (t === 0) return "0m";
  const h = Math.floor(t / 60);
  const m = t % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

function entryDateKey(item) {
  const raw = item?.logDate ?? item?.log_date ?? item?.created_at;
  if (raw == null || String(raw).trim() === "") return "";
  const s = String(raw).trim();
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m) return m[1];
  return formatDateForInput(raw) || "";
}

function entryMinutes(item) {
  const n = Number(item?.minutesLogged ?? item?.minutes_logged ?? item?.minutes ?? 0);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n);
}

/**
 * Sums minutes from GET work-item time-logs rows for today (local) and Mon–today (local week).
 * @param {unknown[]} timeLogs
 * @param {Date} [now]
 * @returns {{ todayMinutes: number, weekMinutes: number }}
 */
export function aggregateWorkItemTimeLogsTodayAndWeek(timeLogs, now = new Date()) {
  const list = Array.isArray(timeLogs) ? timeLogs : [];
  const todayStr = formatDateForInput(now);
  const weekStartStr = formatDateForInput(getMondayOfWeekLocal(now));
  let todayMinutes = 0;
  let weekMinutes = 0;
  for (const item of list) {
    const key = entryDateKey(item);
    if (!key) continue;
    const mins = entryMinutes(item);
    if (mins <= 0) continue;
    if (key === todayStr) todayMinutes += mins;
    if (key >= weekStartStr && key <= todayStr) weekMinutes += mins;
  }
  return { todayMinutes, weekMinutes };
}
